import { Dispatch, SetStateAction } from "react";
import { MenuItem } from "../../utils/Menu";

export type MenuActionType = "toggle" | "background" | "menuGroup" | "menu";
export type MenuStateType = {showSidebar: boolean, showBackground?: boolean, selectedMenuGroup?: MenuItem, selectedMenu?: MenuItem};
export type MenuStateActionType = {type: MenuActionType, showSidebar: boolean, showBackground?: boolean, selectedMenuGroup?: MenuItem | null, selectedMenu?: MenuItem | null};

export const menuInitialState: MenuStateType = {showSidebar: false, showBackground: false};

export default function menuReducer(state: any, action: MenuStateActionType) : MenuStateType {
    // console.log({state, action});
    switch (action.type) {
        case 'toggle':
            return {...state, showSidebar: action.showSidebar};
        case 'background':
            return {...state, showBackground: action.showBackground};
        case 'menuGroup':
            return {...state, selectedMenuGroup: action.selectedMenuGroup};
        case 'menu':
            return {...state, selectedMenu: action.selectedMenu};
        default:
            throw new Error();
    }
}
